<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 头部选项卡 -->
    <div class="topSelece">
      <div
        :class="topSelectActive == v.id ? 'selectActive' : 'select'"
        v-for="(v, i) in topSelectArr"
        :key="i"
        @click="topSelectActive = v.id"
      >
        {{ v.name }}
      </div>
    </div>
    <!-- 合伙人信息 -->
    <div class="mgt-10" v-if="topSelectActive == 1">
      <!-- 信息 -->
      <div class="color0063ea fw-600 mgb-5">合伙人信息</div>
      <el-descriptions border :column="3">
        <el-descriptions-item label="合伙人姓名"
          >{{ form.userName }}
        </el-descriptions-item>
        <el-descriptions-item label="合伙人电话"
          >{{ form.userPhone }}
        </el-descriptions-item>
        <el-descriptions-item label="身份证号"
          >{{ form.identityCard }}
        </el-descriptions-item>
        <el-descriptions-item label="说明"
          >{{ form.particularDesc }}
        </el-descriptions-item>
        <el-descriptions-item label="专属维护人"
          >{{ getLabelByField(people, form.staffId) }}({{
            getLabelByField(people, form.staffId, { label: "phone" })
          }})
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions border :column="4">
        <el-descriptions-item label="分润总收益"
          >{{ shareInfoForm ? shareInfoForm.totalBalance : "--" }}
        </el-descriptions-item>
        <el-descriptions-item label="提现次数"
          >{{ shareInfoForm ? shareInfoForm.withDrawNum : "--" }}
        </el-descriptions-item>
        <el-descriptions-item label="已提现收益"
          >{{ shareInfoForm ? shareInfoForm.withDrawBalance : "--" }}
        </el-descriptions-item>
        <el-descriptions-item label="待提现收益"
          >{{ shareInfoForm ? shareInfoForm.currentBalance : "" }}
        </el-descriptions-item>
        <el-descriptions-item label="图片">
          <el-image
            v-if="imgList.length > 0"
            style="width: 100px; height: 100px;margin-right: 20px"
            v-for="(v, i) in imgList"
            :key="i"
            :src="v"
            :preview-src-list="imgList"
          >
          </el-image>
          <el-empty v-else />
        </el-descriptions-item>
      </el-descriptions>
      <!-- 合伙人奖励提现 -->
      <div class="color0063ea fw-600 mgb-5 mgt-15">合伙人奖励提现</div>
      <el-descriptions border :column="1">
        <el-descriptions-item label="提现方式">
          <span v-if="form.awardWay === 0">全部</span>
          <span v-else-if="form.awardWay === 1">现金提现</span>
          <span v-else-if="form.awardWay === 2">水卡兑换</span>
        </el-descriptions-item>
      </el-descriptions>
      <!--维护人分润信息-->
      <div class="color0063ea fw-600 mgb-5 mgt-15">维护人分润信息</div>
      <el-table :data="form.partnerStaffList" style="width: 100%" border stripe>
        <el-table-column
          type="index"
          :index="indexMethod3"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="afterSalesName" label="分润人"></el-table-column>
        <el-table-column label="分润比例">
          <template #default="{row}">
            {{ row.sharingProportion * 100 }}%
          </template>
        </el-table-column>
        <el-table-column
          prop="newUserRewards"
          label="新用户奖励(元)"
        ></el-table-column>
      </el-table>
      <!-- 分润信息 -->
      <div class="color0063ea fw-600 mgb-5 mgt-15">分润信息</div>
      <el-descriptions border :column="1">
        <el-descriptions-item label="分润方式"
          >合伙人套餐充值
        </el-descriptions-item>
        <!--        <el-descriptions-item label="分润方式">-->
        <!--          新用户开卡<span style="color:red;">(新用户首次充值后奖励)</span>-->
        <!--        </el-descriptions-item>-->
        <!--        <el-descriptions-item label="新用户开卡奖励">{{-->
        <!--          form.newUserState === 1 ? "开启" : "关闭"-->
        <!--        }}</el-descriptions-item>-->
        <!--        <el-descriptions-item v-if="form.newUserState === 1" label="奖励金额"-->
        <!--          >{{ form.awardMoney || "&#45;&#45;" }}元</el-descriptions-item-->
        <!--        >-->
      </el-descriptions>
      <!-- 业绩考核机制 -->
      <div class="color0063ea fw-600 mgb-5 mgt-15">业绩考核机制</div>
      <el-descriptions border :column="2">
        <el-descriptions-item label="业绩考核"
          >{{ form.performanceCheck === 1 ? "开启" : "关闭" }}
        </el-descriptions-item>
        <el-descriptions-item
          label="充值实付指标"
          v-if="form.performanceCheck === 1"
          >{{ form.rechargeTarget }}元
        </el-descriptions-item>
        <el-descriptions-item
          label="考核周期"
          v-if="form.performanceCheck === 1"
          >{{ form.checkPeriod }}天
        </el-descriptions-item>
        <el-descriptions-item
          label="连续未达标次数"
          v-if="form.performanceCheck === 1"
          >{{ form.notQualified }}次
        </el-descriptions-item>
      </el-descriptions>
      <!-- 分配区域 -->
      <div class="flex aic">
        <div class="color0063ea mgr-20 fw-600 mgb-5 mgt-15">分配区域</div>
        <el-button @click="quyuHUIshou">区域回收</el-button>
      </div>
      <customTable
        ref="customTable"
        :api="$api.partner.quyuLiebiao"
        :params="{
          partnerId: id
        }"
        @selection-change="handleSelectionChange"
      >
        <template #columns>
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="50"
            fixed="left"
          >
          </el-table-column>
          <el-table-column prop="regionName" label="区域名称">
          </el-table-column>
          <el-table-column label="分润比例">
            <template #default="{row}">
              {{ row.regionRatio * 100 || "0" }}%
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="分配时间">
          </el-table-column>
        </template>
      </customTable>
    </div>
    <!-- 分润信息 -->
    <div class="mgt-15" v-if="topSelectActive == 2">
      <!-- 表单查询 -->
      <div class="pdt-15 pdb-15 bg-white">
        <el-form ref="fenrunForm" :model="fenrunForm" label-width="90px" inline>
          <el-form-item label="订单编号">
            <el-input
              v-model="fenrunForm.orderNo"
              placeholder="请输入订单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select
              v-model="fenrunForm.orderType"
              placeholder="全部"
              clearable
            >
              <el-option label="充值奖励" value="1"></el-option>
              <el-option label="首充用户奖励" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="水卡编号">
            <el-input
              v-model="fenrunForm.cardNo"
              placeholder="请输入水卡编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属分区">
            <el-select
              clearable
              v-model="fenrunForm.regionId"
              placeholder="全部"
            >
              <el-option
                v-for="(v, i) in fenquArr"
                :key="i"
                :label="v.regionName"
                :value="v.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易时间">
            <el-date-picker
              v-model="fenrunForm.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="fenrunForm.endTime"
              :picker-options="pickerOptionsEnd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="getFenrunList()">查 询</el-button>
            <el-button
              @click="
                fenrunForm = {};
                getFenrunList();
              "
              >重 置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 统计 -->
      <div class="flex aic jcsb">
        <div class="flex aic fw-600 color0063ea mgt-20 mgb-20">
          <span class="mgr-50">分润订单数：{{ fenrunStatForm.shareNum }}</span>
          <span class="mgr-50"
            >充值到账总金额（元）：{{ fenrunStatForm.orderPrice }}</span
          >
          <span class="mgr-50"
            >分润金额（元）：{{ fenrunStatForm.sharePrice }}</span
          >
        </div>
        <el-button @click="exportBtn">导出</el-button>
      </div>
      <!-- 表格 -->
      <el-table :data="fenrunTableData" style="width: 100%" border stripe>
        <el-table-column
          type="index"
          :index="indexMethod2"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="orderNo" label="订单编号"></el-table-column>
        <el-table-column prop="orderType" label="订单类型">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.orderType == 1
                  ? '充值奖励'
                  : scope.row.orderType == 2
                  ? '首充用户奖励'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="cardNo" label="水卡编号"></el-table-column>
        <el-table-column prop="regionName" label="所属分区"></el-table-column>
        <el-table-column prop="payPrice" label="订单实付金额（元）">
        </el-table-column>
        <el-table-column prop="shareProportion" label="相对分润比例">
        </el-table-column>
        <el-table-column prop="sharePrice" label="分润金额（元）">
        </el-table-column>
        <el-table-column prop="address" label="收益状态">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.state == 1
                  ? '未到账'
                  : scope.row.state == 2
                  ? '已到账'
                  : '- -'
              "
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="交易时间"></el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        class="mgt-20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 20, 30, 40, 50]"
        :page-size="pageSize"
        layout=" prev, pager, next"
        :total="total"
      >
      </el-pagination>
      <!-- 导出弹框 -->
      <el-dialog
        title="导出"
        :visible.sync="exportVisible"
        width="30%"
        center
        top="30vh"
      >
        <el-form ref="form" :model="exportForm" label-width="100px">
          <el-form-item label="交易开始时间">
            <el-date-picker
              v-model="exportForm.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="交易结束时间">
            <el-date-picker
              v-model="exportForm.endTime"
              :picker-options="pickerOptionsEnd2"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="mgr-30" @click="exportVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="exportBtnHandle">导 出</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import { assignObject, getLabelByField } from "@/utils/UtilsIf";
import { quyuLiebiao } from "@/api/partner";

export default {
  components: {
    breadcrumbs
  },
  data() {
    return {
      topSelectArr: [
        { id: 1, name: "合伙人信息" },
        { id: 2, name: "分润信息" }
      ],
      topSelectActive: 1,
      tableData: [],
      fenrunForm: {}, //分润信息表单
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.fenrunForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      pickerOptionsEnd2: {
        disabledDate: time => {
          let beginDateVal = this.exportForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      fenrunTableData: [],
      exportVisible: false,
      exportForm: {
        startTime: "",
        endTime: ""
      }, //导出弹框表单
      form: {
        userName: "",
        userPhone: "",
        staffId: "",
        identityCard: "",
        particularDesc: "",
        photoDesc: "",
        // newUserState: 1,
        awardWay: 0,
        // awardMoney: "",
        regionBeanList: [],
        partnerStaffList: [],
        performanceCheck: 0,
        rechargeTarget: "",
        checkPeriod: "",
        notQualified: ""
      },
      id: null,
      imgList: [],
      shareInfoForm: null,
      fenquArr: [],
      people: [],
      multipleSelection: [],
      partnerId: null,
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      fenrunStatForm: {}
    };
  },
  watch: {
    "fenrunForm.startTime"() {
      if (this.fenrunForm.startTime == null) {
        this.fenrunForm.endTime = null;
      }
    },
    "exportForm.startTime"() {
      if (this.exportForm.startTime == null) {
        this.exportForm.endTime = null;
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
      this.addOrEditType = 2;
    }
    this.partnerId = this.$route.query.partnerId;
    this.getShareInfo();
    this.getFenqu();
    this.getFenrunList();
    this.getPeoplePull();
  },
  methods: {
    quyuLiebiao,
    getLabelByField,
    getPeoplePull() {
      this.$api.partner.weihuPeoplePull().then(res => {
        if (res.code === 200) {
          this.people = res.data.list;
        }
      });
    },
    // 区域回收
    quyuHUIshou() {
      if (this.multipleSelection.length == 0) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      let arr = [];
      this.multipleSelection.forEach(v => {
        arr.push(v.id);
      });
      handleConfirm(
        "回收区域后合伙人将无法对区域内的水卡充值，订单不再与合伙人分润，确定回收吗?",
        "info"
      )
        .then(() => {
          this.$api.partner
            .quyuHuiShou({ id: this.id, regionIds: arr })
            .then(res => {
              if (res.code === 200) {
                handleAlert("回收成功", "success");
                this.getDetail();
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 导出
    exportBtnHandle() {
      this.$api.partner
        .shareExport({
          partnerId: this.partnerId,
          orderType: this.fenrunForm.orderType,
          cardNo: this.fenrunForm.cardNo,
          orderNo: this.fenrunForm.orderNo,
          regionId: this.fenrunForm.regionId,
          startDay: this.exportForm.startTime,
          endDay: this.exportForm.endTime
        })
        .then(res => {
          handleAlert("导出成功", "success");
          this.exportVisible = false;
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = URL.createObjectURL(res);
          link.setAttribute("download", "分润信息.xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    // 分区下拉
    getFenqu() {
      this.$api.marketing.allZonePull().then(res => {
        if (res.code === 200) {
          this.fenquArr = res.data;
        }
      });
    },
    // 分润列表
    getFenrunList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.partner
        .shareList({
          pageNum: this.page,
          pageSize: this.pageSize,
          partnerId: this.partnerId,
          orderType: this.fenrunForm.orderType,
          cardNo: this.fenrunForm.cardNo,
          orderNo: this.fenrunForm.orderNo,
          regionId: this.fenrunForm.regionId,
          startDay: this.fenrunForm.startTime,
          endDay: this.fenrunForm.endTime
        })
        .then(res => {
          if (res.code === 200) {
            this.fenrunTableData = res.data.rows;
            this.total = res.data.total;
            this.getFenrunStat();
          }
        });
    },
    // 分润统计
    getFenrunStat() {
      this.$api.partner
        .shareStat({
          partnerId: this.partnerId,
          orderType: this.fenrunForm.orderType,
          cardNo: this.fenrunForm.cardNo,
          orderNo: this.fenrunForm.orderNo,
          regionId: this.fenrunForm.regionId,
          startDay: this.fenrunForm.startTime,
          endDay: this.fenrunForm.endTime
        })
        .then(res => {
          if (res.code === 200) {
            this.fenrunStatForm = res.data;
          }
        });
    },
    // 分润信息
    getShareInfo() {
      this.$api.partner.shareInfo({ partnerId: this.partnerId }).then(res => {
        if (res.code === 200) {
          this.shareInfoForm = res.data;
        }
      });
    },
    // 回显--详情
    async getDetail() {
      const res = this.$api.partner.partnerDetail({ id: this.id }).then(res => {
        if (res.code === 200) {
          let data = res.data;
          this.imgList = [];
          if (data.photoDesc) {
            (data.photoDesc.split(",") || []).forEach(item => {
              this.imgList.push(item);
            });
          }
          this.form = assignObject(this.form, data);
          this.$refs.customTable.loadData();
        }
      });
    },
    exportBtn() {
      this.exportForm = {
        startTime: "",
        endTime: ""
      };
      this.exportVisible = true;
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod2(index) {
      return index + 1;
    },
    //表格序号，根据索引+1
    indexMethod3(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getFenrunList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getFenrunList(this.page);
    }
  }
};
</script>

<style lang="scss" scoped>
.topSelece {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .select {
    width: 300px;
    height: 35px;
    // border: 2px solid var(--input-border);
    text-align: center;
    line-height: 35px;
    margin-right: 35px;
    background: var(--card-bg);
    cursor: pointer;
  }

  .selectActive {
    width: 300px;
    height: 35px;
    // border: 2px solid var(--input-border);
    text-align: center;
    line-height: 35px;
    margin-right: 35px;
    background: var(--accent);
    color: #fff;
    cursor: pointer;
  }
}
</style>
